import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { DynamicSchemaFieldKey, FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Divider as _Divider } from '@material-ui/core';
import { ClassAttributes, createElement, ReactElement } from 'react';

import {
  DynamicSchemaDefinition,
  DynamicSchemaDefinitionChoice,
  DynamicSchemaDefinitionFiles,
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSection,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionSingleLineText,
  DynamicSchemaDefinitionToggle,
} from '../../../../graphql/generated/graphql';
import { ProjectType } from '../../../../service/persistent/ProjectWebApi';
import { SPACING_UNIT } from '../../../constant/spacing';
import Field from './Field';
import _Section from './Section';

// optionalでbefore, latestのProjectをうけとる
interface Props {
  definition: Pick<DynamicSchemaDefinition, 'id'> & {
    sections: Array<
      Pick<DynamicSchemaDefinitionSection, 'id' | 'label' | 'meta'> & {
        fields: Array<
          | Pick<DynamicSchemaDefinitionFiles, 'key' | 'type' | 'label'>
          | Pick<DynamicSchemaDefinitionFixed, 'key' | 'type' | 'label' | 'value'>
          | Pick<DynamicSchemaDefinitionMultiLineText, 'key' | 'type' | 'label'>
          | Pick<DynamicSchemaDefinitionPositiveInteger, 'key' | 'type' | 'label'>
          | (Pick<DynamicSchemaDefinitionSelectMultiple, 'key' | 'type' | 'label'> & {
              choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>>;
            })
          | (Pick<DynamicSchemaDefinitionSelectOne, 'key' | 'type' | 'label'> & {
              choices: Array<Pick<DynamicSchemaDefinitionChoice, 'key' | 'label'>>;
            })
          | Pick<DynamicSchemaDefinitionSingleLineText, 'key' | 'type' | 'label'>
          | Pick<
              DynamicSchemaDefinitionToggle,
              'key' | 'type' | 'label' | 'checkedControlLabel' | 'uncheckedControlLabel'
            >
        >;
      }
    >;
  };
  value:
    | {
        definition: ProjectType['creativeBriefDefinition'];
        values: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
      }
    | undefined;
  files: Map<DynamicSchemaFieldKey, FileReference[]>;
  className?: string;
}

const CreativeBriefDetail = ({ definition, value, files, className }: ClassAttributes<HTMLElement> & Props) => {
  const sections = definition.sections
    .reduce((whole, section) => {
      const fields = section.fields.map((field) => {
        const tmpValue = value?.values.get(field.key);
        return (
          <Field
            field={field}
            value={tmpValue === undefined ? null : tmpValue}
            files={files.get(field.key)}
            key={field.key}
          />
        );
      });

      return [
        ...whole,
        <Section section={section} key={section.id}>
          {fields}
        </Section>,
        <Divider key={`div-${section.id}`} />,
      ];
    }, [] as ReactElement<any>[])
    .slice(0, -1);

  return <div className={className}>{sections}</div>;
};

const Section = styled(_Section)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

const Divider = styled(_Divider)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

export default CreativeBriefDetail;
